import React from 'react'
import { ArrowForwardIos } from '@mui/icons-material'
import { Grid, Typography } from '@mui/material'
import { connect } from 'react-redux'
import * as common from '../../appRedux/actions/common'
import * as router from '../../constants/router'
import useStyles from './styles'

function Comeback(props) {
    const classes = useStyles()
    let title = props.title || ''
    let redirectLink = props.redirectLink === false ? false : props.redirectLink || router.HOME
    let type = props.type || 'link'

    const comebackFunc = () => {
        if (type === 'link') {
            props.redirectAction(redirectLink)
            if (redirectLink === router.HOME) props.navigationAction(0)
        }
        else props.click()
    }

    return (
        <Grid>
            <Grid className={classes.gridIcon}>
                {redirectLink ? <ArrowForwardIos onClick={() => comebackFunc()} className={classes.icon} /> : ''}
            </Grid>
            <Grid className={classes.gridTypography}>
                <Typography data-testid="content-title" variant="h1">
                    {title}
                </Typography>
            </Grid>
        </Grid>

    )
}


const mapDispatchToProps = (dispatch) => {
    return {
        redirectAction: (data) => dispatch(common.redirectAction(data)),
        navigationAction: (data) => dispatch(common.navigationAction(data)),
    }
}

export default connect(null, mapDispatchToProps)(Comeback)
